import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Facebook } from '@ionic-native/facebook/ngx';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import {
  SignInWithApple,
  ASAuthorizationAppleIDRequest,
} from '@ionic-native/sign-in-with-apple/ngx';
import { Platform } from '@ionic/angular';
import firebase from 'firebase/app';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  userData: User = {};

  constructor(
    public afAuth: AngularFireAuth,
    public platform: Platform,
    public google: GooglePlus,
    public facebook: Facebook,
    public apple: SignInWithApple
  ) {}

  getUserData() {
    return this.userData;
  }

  setUserData(user: any) {
    this.userData.uid = user.uid;
    this.userData.email = user.email;
    this.userData.displayName = user.displayName;
    this.userData.photoURL = user.photoURL;
    this.userData.emailVerified = user.emailVerified;
  }

  async loginWithAnonymously() {
    const promise = new Promise((resolve, reject) => {
      this.afAuth.signInAnonymously().then((data) => {
          // Success
          resolve(data);
        }).catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          reject(`login failed ${error.message}`);
          console.log('login failed', errorMessage, errorCode);
        }
      );
    });
    return promise;
  }

  async loginWithGoogle() {
    if (this.platform.is('cordova')) {
      const response = await this.google.login({});
      const userDataGoogle = response;
      return this.afAuth.signInWithCredential(firebase.auth.GoogleAuthProvider.credential(null, userDataGoogle.accessToken));
    } else {
      return this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
    }
  }

  async loginWithFacebook() {
    if (this.platform.is('cordova')) {
      const response = await this.facebook.login(['email', 'public_profile']);
      const userDataFacebook = firebase.auth.FacebookAuthProvider.credential(
        response.authResponse.accessToken
      );
      return this.afAuth.signInWithCredential(userDataFacebook);
    } else {
      return this.afAuth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
    }
  }

  async loginWithApple() {
    if (this.platform.is('cordova')) {
      const response = await this.apple.signin({
        requestedScopes: [
          ASAuthorizationAppleIDRequest.ASAuthorizationScopeFullName,
          ASAuthorizationAppleIDRequest.ASAuthorizationScopeEmail,
        ],
      });
      const userDataApple = response;
      return this.afAuth.signInWithCredential(new firebase.auth.OAuthProvider('apple.com').credential(userDataApple.identityToken));
    } else {
      return this.afAuth.signInWithPopup(new firebase.auth.OAuthProvider('apple.com'));
    }
  }
}
